"use client";
import { useRouter } from "next/navigation";


export default function AnimatedLink({ href, children, className }) {
	const router = useRouter();


	const handleClick = (e) => {
		e.preventDefault();
		if (href === window.location.pathname) return;


		document.body.classList.add("page-exit");

		sessionStorage.setItem("nextHref", href);

		setTimeout(() => {
			window.scrollTo({ top: 0, left: 0, behavior: "auto" });
			router.push(href);
		}, 1000);
	};


	return (
		<a href={href} onClick={handleClick} className={className}>
			{children}
		</a>
	);
}